import * as React from 'react';
import { Card, CardContent, Button } from '../../Components';
import styled from 'styled-components';
import { AUTH_STORE, AuthStore } from '../../Store/Auth';
import { observer, inject } from 'mobx-react';

interface IProps {
  [AUTH_STORE]: AuthStore;
}

const StyledCardContent = styled(Card)`
  text-align: center;
`;

const StyledTitle = styled.h1`
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 30px;
`;

const StyledButton = styled(Button)`
  padding-left: 30px;
  padding-right: 30px;
`;

export const MonografiaNotFound : React.FC<IProps> =
  inject(AUTH_STORE)
  (observer((props: IProps) => {
    const authStore = props[AUTH_STORE];

    return (
      <StyledCardContent>
        <CardContent>
          <StyledTitle>Ainda não foi designado um orientador ao seu projeto ou então não há registro em seu nome. Caso julgue que há algum erro, procure o Nuprajur</StyledTitle>
          <StyledButton type="button" onClick={authStore.logout}>Sair</StyledButton>
        </CardContent>
      </StyledCardContent>
    );
  }));